const getLabels = (appCtx) => {
  const textDictionary = appCtx.siteConfig?.textDictionary ?? {};
  return {
    text1: textDictionary.WHOLESALE_BANNER_BADGE_TEXT_1 ?? 'Precio',
    text2: textDictionary.WHOLESALE_BANNER_BADGE_TEXT_2 ?? 'Volumen',
    from: textDictionary.WHOLESALE_BANNER_BADGE_FROM ?? 'desde',
    each: textDictionary.WHOLESALE_BANNER_BADGE_EACH ?? 'cada',
    units: textDictionary.WHOLESALE_BANNER_BADGE_UNITS ?? 'un.',
  };
};

export default getLabels;
